import React, { FC } from "react"
import { Spacer } from "../../atoms/Atoms"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../../atoms/Bodies"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"
import { SupportCenterLinks } from "../../../../utils/SupportCenterLinks"
import { RRIconBar } from "components/views/atoms/roundedrectangle/RRIconBar"
import { ZendeskArrowLink } from "../../atoms/links/ZendeskArrowLink"
import { FormattedMessage } from "react-intl"

const CarrotCardEligibleWithDeductibleModule: FC<CarrotCardModuleProps> = () => (
  <RoundedRectangle backgroundColor="pampas">
    <RRIconBar iconName="icn-carrot-cards" iconBackgroundColor="white-60" />
    <H3 variant="primary" stack="tiny">
      <FormattedMessage defaultMessage="Carrot Card®" />
    </H3>
    <BodySmall color="black-80">
      <FormattedMessage defaultMessage="As soon as your deductible is met, you'll be eligible for a Carrot Card, which makes it easy to pay directly from your account." />
    </BodySmall>
    <Spacer height={0.5} />
    <ZendeskArrowLink supportCenterLink={SupportCenterLinks.CARROT_CARD_SUPPORT_CENTER}>
      <FormattedMessage defaultMessage="Learn how Carrot Card works" />
    </ZendeskArrowLink>
  </RoundedRectangle>
)

export { CarrotCardEligibleWithDeductibleModule }
